import React, { memo, useCallback, useState } from 'react';
import { useRouter } from 'next/router';

import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import ProductCard from '~/src/components/ProductCard';
import { getPriceOptions } from '~/src/entities/equipment';
import { convertShopPrices } from '~/src/entities/price';
import { dataLayerPushWrap } from '~/src/features/yandex-landing/utils';

export const YandexStationCard = ({ item }: { item: IEquipment }): JSX.Element => {
    const router = useRouter();
    const [indexOfSelected, setIndexOfSelected] = useState(0);

    const openDetailPage = useCallback(() => {
        router.push(`/internet/yandex-stanciya/${item.alias}?withOption=${indexOfSelected}`);
        dataLayerPushWrap({ label: `${item.title}` });
    }, [router, item, indexOfSelected]);

    return (
        <ProductCard
            key={item.id}
            image={item.image}
            baseRoute='/internet/yandex-stanciya'
            backgroundColorData={ { bgImg: COLORS.BgMain } }
            categoryTitle={item.category?.title}
            name={item.title}
            body={item.body}
            priceOptions={getPriceOptions(convertShopPrices(item))}
            labels={item.labels}
            detailHandler={openDetailPage}
            setIndexOfSelected={setIndexOfSelected}
        />
    );
};

export default memo(YandexStationCard);
